import { CardClickPopupType } from '@colonist/game-card-types';
import { CardEnum, CardTypeEnum } from '@colonist/game-states';
export function getMiscellaneousCardData() {
    return [
        {
            cardEnum: CardEnum.ResourceOverLimit,
            cardTypeEnum: CardTypeEnum.Miscellaneous,
            isCardBack: false,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.ProgressCardBack,
            cardTypeEnum: CardTypeEnum.Miscellaneous,
            isCardBack: false,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        }
    ];
}
